/**
 * Labstep
 */

export const RESET_POSITION = 'RESET_POSITION';

export const resetPositionActionCreator = (
  entityName: any,
  entities: any,
) => ({
  type: RESET_POSITION,
  entityName,
  entities,
});
